import LocalStorageManager from 'managers/LocalStorageManger';
import { postMethod } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const VERIFY_OTP = 'VERIFY_OTP';
export const VERIFY_OTP_SUCCESS = 'VERIFY_OTP_SUCCESS';
export const VERIFY_OTP_FAILURE = 'VERIFY_OTP_FAILURE';

// Action Creators
export const fetchVerifyOtp = () => ({
  type: VERIFY_OTP,
});

export const fetchVerifyOtpSuccess = (data) => ({
  type: VERIFY_OTP_SUCCESS,
  payload: data,
});

export const fetchVerifyOtpFailure = (error) => ({
  type: VERIFY_OTP_FAILURE,
  payload: error,
});

// Thunk Function
export const verifyOtpCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchVerifyOtp(data, external));
    try {
      const response = await postMethod(url.verifyOtp, data);
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchVerifyOtpSuccess(response.data));

        LocalStorageManager.setItem('token', response?.data?.data?.key);
        LocalStorageManager.setItem('Role', response?.data?.data?.role);

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchVerifyOtpFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchVerifyOtpFailure(error.message));
    }
  };
};
